<template>
  <div class="banner">
    <div class="banner-text">
      <div>
        北京金融街教学数据系统
      </div>
    </div>
    <div class="timer">
      <timer />
    </div>
  </div>
</template>

<script>
import timer from './timer.vue'
export default {
  components: {
    timer
  }
}
</script>

<style scoped>
.banner-text {
  width: 100%;
  height: 100px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  color: white;
}
.banner {
  box-sizing: border-box;
  width: 1920px;
  height: 137px;
  background-image: url('@/assets/banner.png');
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  right: 0;
}
.timer {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  margin-top: 18px
}
</style>